import { kdf } from 'crypto-js';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state:{
		login_load:false,
		main_loading_spinner : false,
		main_loading_spinner_text : "Obrađujem podatke",
		signature : "<p>--------------</p>",
		// PWA state - managed by mutations for proper reactivity
		pwa: {
			canInstall: false,
			isInstalled: false,
			isOnline: true,
			updateAvailable: false
		},
		ime_predmeta:{
			broj_predmeta:'',
			ime_stranke:'',
			ime_protustranke:''
		},
		paginacija:{
			title:'PSOD ERP',
			subpages:[],
			back_link:''
		},
		event_details:{
			popup_open:false,
			chosen_event:null,
			selected_day:null,
			selected_type:0,
			pending_event_id: null, // Event ID to auto-open when calendar loads
			pending_event_date: null, // Date of the pending event (for calendar navigation)
		},
		all_files_tags : [],
		file_tag_filter : [],
		chosen_date:null,
		chosen_type:1,
		notifies_shown:false,
		sioVar:null,
		vrsta_osobe:1,
		rocista_tab_active:false,
		rocista_report_data:{events:null,razdoblje:''},
		edit_data:null,
		project_task_progress:0,
		last_page_name:"",
		// currency_data:{
		// 	input_value:0,
		// 	drop_value:1,
		// },
		shared_input_value:'',
		predmeti_report_data:{
			all_predmeti: [],
			naslov: '',
			odvjetnik_nositelj:null,
			odvjetnik_name:'',
			is_general_view:false,
		},
		people_report_data:{
			all_people: [],
			naslov: '',
			izvor:"",
			prikaz:'',
			vrsta_osobe:"",
		},
		spis_active_pic:null,
		spis_overlay_open:false,
		view_cases_by_logged_person:false,
		troskovnik_data:null,
		edit_troskovnik_data:null,
		breakdown_satnice:null,
		troskovnik_unsaved_changes:false,
		troskovnik_pdf_view:false,
		naplata_report_data:{
			all_troskovnici:[],
		},
		current_report_type:'rocista',
		release_notes_open:false,
		breakdown_report_data:null,
		case_state_report:{
			all_cases_states_reports:null,
			stranka:'',
		},
		is_intentional_reload:false,
		// Case and project data - added for proper Vue reactivity
		current_selected_case: null,
		current_selected_proj: null,
		logged_in_user: null,
		aToken: null,
		mapped_case_permission: null,
		user_project_permissions: null,
		availableFileTags: [],
	},
	mutations: {
		// PWA mutations for proper Vue reactivity
		SET_PWA_CAN_INSTALL(state, value) {
			state.pwa.canInstall = value;
		},
		SET_PWA_INSTALLED(state, value) {
			state.pwa.isInstalled = value;
			if (value) state.pwa.canInstall = false;
		},
		SET_PWA_ONLINE(state, value) {
			state.pwa.isOnline = value;
		},
		SET_PWA_UPDATE_AVAILABLE(state, value) {
			state.pwa.updateAvailable = value;
		},
		// Mutation for setting current case data
		SET_CURRENT_CASE(state, caseData) {
			console.log('[Vuex Mutation] SET_CURRENT_CASE called with:', caseData && caseData.group_url);
			state.current_selected_case = caseData;
			console.log('[Vuex Mutation] Case data set in state:', state.current_selected_case && state.current_selected_case.group_url);
		},
		// Mutation for clearing current case data
		CLEAR_CURRENT_CASE(state) {
			console.log('[Vuex Mutation] CLEAR_CURRENT_CASE called');
			state.current_selected_case = null;
		},
		// Mutation for setting current project data
		SET_CURRENT_PROJECT(state, projectData) {
			state.current_selected_proj = projectData;
		},
		// Mutation for clearing current project data
		CLEAR_CURRENT_PROJECT(state) {
			state.current_selected_proj = null;
		}
	}
});